<template>
  <div>
    <nav-bar />

    <div id="app" class="container is-fluid">
      <router-view />
    </div>
    <footer-bar />
    <overlay />
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import NavBar from "@/components/NavBar";
import FooterBar from "@/components/FooterBar";
import Overlay from "@/components/Overlay";

export default {
  name: "App",
  components: {
    Overlay,
    FooterBar,
    NavBar
  },
  data() {
    return {
      menuSecondary: null,
      menuSecondaryLabel: null,
      menuSecondaryIcon: null
    };
  },
  computed: {
    ...mapState(["isOverlayVisible"])
  },
  created() {
    if (!this.$cookies.isKey("user_token")) {
      this.$auth.logout({
        returnTo: window.location.origin
      });
    }
  },
  methods: {
    menuClick(item) {
      if (item.menuSecondary) {
        this.menuSecondary = item.menuSecondary;
        this.menuSecondaryLabel = item.menuSecondaryLabel
          ? item.menuSecondaryLabel
          : null;
        this.menuSecondaryIcon = item.menuSecondaryIcon
          ? item.menuSecondaryIcon
          : null;

        this.$store.commit("asideActiveForcedKeyToggle", item);
        this.$store.commit("overlayToggle", true);
      } else if (item.action && item.action === "logout") {
        this.$auth.logout();
        this.$buefy.toast.open({
          message: "Log out clicked",
          type: "is-danger",
          queue: false
        });
      }
    },
    menuSecondaryCloseClick() {
      this.$store.commit("overlayToggle", false);
    },
    menuSecondaryClose() {
      this.menuSecondary = this.menuSecondaryLabel = this.menuSecondaryIcon = null;
      this.$store.commit("asideActiveForcedKeyToggle", null);
    }
  },
  watch: {
    isOverlayVisible(newValue) {
      if (!newValue) {
        this.menuSecondaryClose();
      }
    }
  }
};
</script>
